const DetailView=(e)=>{
         try{
            photoOrg.cLog("DetailView triggered from single album view");

            photoOrg.Util.trackLinksAndButtons('Magnifying Icon',photoOrg.constants.pageNames[photoOrg.history.historyState.pg])

            photoOrg.photoLib.isSelectedImagesDetailedView = false;
            //this is normal detailed view but not project tray detailed view
            var modelId = photoOrg.photoLib.htmlEncode($(e.currentTarget).parent().attr('id'));
            modelId = photoOrg.Util.removeSpecialCharsFromId(modelId);

            if(!modelId){
                //if modelId is not derived from parent pick from img tag sibling
                modelId = photoOrg.photoLib.htmlEncode($(e.currentTarget).siblings(".assetImg").attr("id"));
                modelId = photoOrg.Util.removeSpecialCharsFromId(modelId);
            }

            var model=photoOrg.photoLib.UserAssetsInfo.singleAlbumsAssets.get(modelId);

            if(!model){
                var e="unable to find model object for id : "+modelId
                photoOrg.clientLogger.error({description: "SHARE:public_share_landing_page:detailView", errorCode: "LIBRARY:SHARE", err_desc: e, err_stack: e.stack});
                return;
            }

            $('#detailedViewContainer').empty();

            var window_height=$(window).height()*0.7;

            var context = {
                "modelId": model.id,
                "detailedViewHeight": window_height,
                "accessType": photoOrg.photoLib.accessType.guest
            };
            var html = JST['templates/common/library/detail_view/detailed-view-container'](context);
            $('#detailedViewContainer').html(html);
            $('#detailedViewContainer').show();
            $('#detailedViewContainer').css('visibility','visible');


            photoOrg.detailedView = new photoOrg.DetailedView({el : photoOrg.photoLib.getElementById('detailedView_'+model.get("assetId")),"model" :model,"accessType": context.accessType,"albId":"",'heroImageId':""});
        }
        catch(e){
            photoOrg.clientLogger.error({description: "SHARE:public_share_landing_page:detailView:Exception", errorCode: "LIBRARY:SHARE", err_desc: e, err_stack: e.stack});
        }

    }

export default DetailView;